import React from 'react';

import { getTranslation } from 'helpers/getTranslation';

import { Typography } from 'components/shared/Typography';

import {
  formatPreciseSeconds,
  type SlowEventDetails,
} from '../../TimelineSection.helpers';

import styles from './SlowDetails.module.scss';

/**
 * Fill/Light/Warning card: «Сервер отвечал 5,4 с [bar] обычно до 3 с» («Ждал 14,3 с»
 * for a screen that never loaded — its row title says «так и не открылся»); the raw
 * request / stage in the «Технические детали» mode only.
 */
const SlowDetails = ({
  details,
  techMode = false,
}: {
  details: SlowEventDetails;
  techMode?: boolean;
}) => (
  <div className={styles.card}>
    {techMode && details.devTarget ? (
      <Typography className={styles.devTarget} variant="body3" mode="compact">
        {details.devTarget}
      </Typography>
    ) : null}
    <div className={styles.duration}>
      <Typography
        className={styles.durationValue}
        component="span"
        variant="body3"
        weight="semiBold"
        mode="compact"
      >
        {details.durationLabel}
      </Typography>
      <span className={styles.track}>
        <span
          className={styles.fill}
          style={{ width: `${details.fillPercent}%` }}
        />
        <span
          className={styles.threshold}
          style={{ left: `${details.thresholdPercent}%` }}
          title={getTranslation(
            'student_page.journey.slow_details.threshold_marker',
          )}
        />
      </span>
      <Typography
        className={styles.thresholdText}
        component="span"
        variant="body3"
        mode="compact"
      >
        {getTranslation('student_page.journey.slow_details.threshold', {
          threshold: formatPreciseSeconds(details.thresholdMs),
        })}
      </Typography>
    </div>
  </div>
);

export default React.memo(SlowDetails) as any;
